import React from 'react'
import BookingCancelationListForm from '../../features/BookingCancelation/BookingCancelationListForm'

const BookingCancelation = () => {
    return (
        <BookingCancelationListForm />
    )
}

export default BookingCancelation